import React from 'react';
import cx from 'classnames';

import { useSearchContext } from '@atlas/core';

import { useSearch } from 'hooks/useSearch';

import { useSearchInputState } from './context/InputProvider';
import SearchList from './SearchList';

const SearchListContainer = () => {
  const { searchString } = useSearch();
  const { loading } = useSearchContext();
  const { focused, isIframe } = useSearchInputState();

  const className = cx('search-list', {
    frame: isIframe,
    loading,
    touched: focused && !searchString,
  });

  if (!focused) return null;

  return (
    <div className={className}>
      <SearchList />
    </div>
  );
};

export default SearchListContainer;
